import { useState } from "react";
import { supabase } from "../lib/supabase";
import { isNativePlatform, registerNativePush } from "../lib/native-push";

export function useNotifications() {
  const [notificationsEnabled, setNotificationsEnabled] = useState(
    () => typeof Notification !== "undefined" && Notification.permission === "granted"
  );

  const handleEnableNotifications = async () => {
    // Native app (iOS): use APNs via Capacitor; Web Push does not work here.
    if (isNativePlatform()) {
      const granted = await registerNativePush();
      setNotificationsEnabled(granted);
      return;
    }

    if (typeof Notification === "undefined") return;
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        setNotificationsEnabled(true);
        const reg = await navigator.serviceWorker?.ready;
        if (reg?.pushManager) {
          const sub = await reg.pushManager.getSubscription();
          if (!sub) {
            const vapidKey = import.meta.env.VITE_VAPID_PUBLIC_KEY;
            if (vapidKey) {
              const newSub = await reg.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: vapidKey,
              });
              try {
                const headers = { "Content-Type": "application/json" };
                const { data: { session: s } } = await supabase.auth.getSession();
                if (s?.access_token) headers.Authorization = `Bearer ${s.access_token}`;
                await fetch(
                  `${import.meta.env.VITE_API_URL || ""}/api/push-subscribe`,
                  { method: "POST", headers, body: JSON.stringify({ subscription: newSub.toJSON() }) }
                );
              } catch { /* push subscription failed */ }
            }
          }
        }
      }
    } catch { /* notification setup failed */ }
  };

  return { notificationsEnabled, handleEnableNotifications };
}
